(() => {
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const common = ['brand', 'vendor', 'availability', 'price'];
  const policies = [
    [/mattress/, ['size', 'firmness', 'comfort', 'features', 'brand', 'vendor', 'availability', 'price', 'mattress type', 'type', 'thickness', 'cooling']],
    [/(bunk|loft)/, ['size', 'configuration', 'features', 'color', 'finish', 'material', 'storage', 'trundle', 'desk', 'stairs or ladder', 'stairs / ladder', 'brand', 'vendor', 'availability', 'price']],
    [/adjustable/, ['size', 'features', 'massage', 'lumbar support', 'full motion', 'brand', 'vendor', 'availability', 'price']],
    [/sectional/, ['configuration', 'orientation', 'color', 'material', 'style', 'reclining', 'sleeper', 'storage', 'features', 'brand', 'vendor', 'availability', 'price']],
    [/(bedroom|\bbeds?\b|headboard|dresser|nightstand|chests|vanities)/, ['bed type', 'size', 'color / finish', 'color', 'finish', 'material', 'style', 'storage', 'features', 'brand', 'vendor', 'availability', 'price']],
    [/(living|sofa|loveseat|recliner)/, ['color', 'finish', 'material', 'style', 'configuration', 'reclining', 'sleeper', 'features', 'brand', 'vendor', 'availability', 'price']],
    [/dining/, ['seats', 'shape', 'color', 'finish', 'material', 'style', 'counter height', 'features', 'brand', 'vendor', 'availability', 'price']],
    [/(office|desk)/, ['color', 'finish', 'material', 'style', 'storage', 'features', 'brand', 'vendor', 'availability', 'price']],
    [/(pillow|protector|bedding)/, ['size', 'color', 'material', 'cooling', 'waterproof', 'features', 'brand', 'vendor', 'availability', 'price']]
  ];

  function collectionKey() {
    const title = document.querySelector('.bedz-collection-header__title')?.textContent || '';
    const path = window.location.pathname.replace('/collections/', '').replaceAll('-', ' ');
    return normalize(`${title} ${path}`);
  }

  function allowedLabels() {
    const key = collectionKey();
    const match = policies.find(([pattern]) => pattern.test(key));
    return new Set(match ? match[1] : common);
  }

  function labelForDisclosure(disclosure) {
    return normalize(disclosure.querySelector('.facets__summary span:first-child')?.textContent).replace(/^color\s*\/\s*finish$/, 'color');
  }

  function applyPolicy(root = document) {
    if (!document.body.classList.contains('template-collection')) return;

    const allowed = allowedLabels();
    root.querySelectorAll('.facets__disclosure').forEach((disclosure) => {
      if (disclosure.classList.contains('bedz-browse-facet')) {
        disclosure.hidden = false;
        disclosure.setAttribute('aria-hidden', 'false');
        return;
      }
      const label = labelForDisclosure(disclosure);
      const rawTagFilter = label === 'tag' || label === 'tags' || label.includes('internal');
      disclosure.hidden = rawTagFilter || !allowed.has(label);
      disclosure.setAttribute('aria-hidden', disclosure.hidden ? 'true' : 'false');
    });

    const visible = [...root.querySelectorAll('.facets__disclosure')].filter((item) => !item.hidden);
    const heading = root.querySelector('.facets__heading');
    if (heading) heading.hidden = visible.length === 0;
  }

  document.addEventListener('DOMContentLoaded', () => applyPolicy());

  // Shopify's AJAX collection filtering replaces portions of the DOM.
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) applyPolicy();
  });

  document.addEventListener('DOMContentLoaded', () => {
    const filters = document.querySelector('#main-collection-filters');
    if (filters) observer.observe(filters, { childList: true, subtree: true });
  });
})();
